/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availabilitySchemeMemberSchema = z.object({
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  id: z.int(),
  instanceId: z.string().nullish(),
  lastSyncedAt: z.iso.datetime().nullish(),
  organizationId: z.string(),
  resourceId: z.int(),
  schemeId: z.int(),
  sourceId: z.string().nullish(),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
